import { useEffect, useState } from "react"

/** Coarse enough that a 24h window's boundary lands within a minute. */
const TICK_MS = 60_000

/**
 * The current time, re-read every minute while `isActive`.
 *
 * Retractability is a function of the clock, so reading `Date.now()` during
 * render leaves the affordance stale until something else re-renders — a
 * thread nobody is typing in would keep its menu indefinitely. Ticking beats
 * a timer per message, and being up to a minute late against a window
 * measured in hours is invisible.
 */
export function useNow(isActive: boolean): number {
  const [now, setNow] = useState(() => Date.now())

  useEffect(() => {
    if (!isActive) return

    const interval = window.setInterval(() => setNow(Date.now()), TICK_MS)

    return () => window.clearInterval(interval)
  }, [isActive])

  return now
}
